var $ = require('jquery');

$(document).ready(function () {
    if ($('.extended-content_contact-item__info__connect').length !== 0) {
        // display phone number from hidden span
        $('.phone-link').on('click', function (event) {
            var phoneId = $(this).data('phone-id');

            toggleHiddenPhone(phoneId, true);
        });

        $('.extended-content_contact-item__info__connect--phone-display span.close-phone').on('click', function (event) {
            var phoneId = $(this).data('phone-id-close');
            toggleHiddenPhone(phoneId, false);
        });
    }
});

function toggleHiddenPhone(phoneId, visible) {
    var hiddenPhoneEl = $('#' + phoneId);

    if (hiddenPhoneEl !== 'undefined' || hiddenPhoneEl !== 0) {
        if (visible) {

            $('.extended-content_contact-item__info__connect[data-contact-id="' + phoneId + '"] .connect').addClass('connect-hidden');
            hiddenPhoneEl.addClass('show');
        } else {
            $('.extended-content_contact-item__info__connect[data-contact-id="' + phoneId + '"] .connect').removeClass('connect-hidden');
            hiddenPhoneEl.removeClass('show');
        }
    }
}

function initializeSlickForExtendedContentContacts(slickState) {

    if (slickState) {
        if (!$('.extended-content_contact--carousel').hasClass('slick-initialized')) {
            $('.extended-content_contact--carousel').slick({
                infinite: false,
                arrows: false,
                centerMode: true,
                centerPadding: '15px',
                centerMode: true,
                variableWidth: true,
                mobileFirst: true,
                responsive: [
                    {
                        settings: {
                            settings: 'unslick'
                        }
                    }
                ],
                rtl: window.GenericUtilities.isRTL()
            });
        }
    } else {
        if ($('.extended-content_contact--carousel').hasClass('slick-initialized')) {
            $('.extended-content_contact--carousel').slick('unslick');
        }
    }
}

$(function () {

    if (window.innerWidth <= 991) {
        initializeSlickForExtendedContentContacts(true);
    }

    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {

        if (window.innerWidth <= 991) {
            initializeSlickForExtendedContentContacts(true);
        } else {
            initializeSlickForExtendedContentContacts(false);
        }
    });
});